
<template>
  <div>
    <b-row class="float-right mb-3">
      <span>Exibir</span>
      <select class="ml-2" v-model="rowsPerPage">
        <option v-for="pageSize in pageSizeMenu" :value="pageSize" v-bind:key="pageSize">
          {{ pageSize }}
        </option>
      </select>
      <span class="ml-2 mr-3">Linhas</span>
    </b-row>

    <b-table responsive stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="rowsPerPage"
      :tbody-tr-class="rowClass"
      show-empty :small="true" select-mode="multi" :bordered="false" striped hover
      empty-filtered-text="Tente navamente mais tarde. Erro inesperado na rotina de debitosGrupos." primary-key="id" summary="Tabela Postagem Faixa AR">

      <template #head(DESCRICAO)="item">
        <div class="a" style="width: 90px">
          <span>{{ item.label }}</span>
        </div>
      </template>

      <template #head(TIPO_FAIXA)="item">
        <div class="a" style="width: 100px">
          <span>{{ item.label }}</span>
        </div>
      </template>

      <template #head(NUM_INICIAL)="item">
        <div class="a" style="width: 80px">
          <span>{{ item.label }}</span>
        </div>
      </template>

      <template #head(NUM_FINAL)="item">
        <div class="a" style="width: 80px">
          <span>{{ item.label }}</span>
        </div>
      </template>
       <template #head(NUM_DISPONIVEL)="item">
        <div class="a" style="width: 80px">
          <span>{{ item.label }}</span>
        </div>
      </template>
      <template #head(DATA_INCLUSAO)="item">
        <div class="a" style="width: 80px">
          <span>{{ item.label }}</span>
        </div>
      </template>
      <template #head(DATA_VALIDADE)="item">
        <div class="a" style="width: 80px">
          <span>{{ item.label }}</span>
        </div>
      </template>
      <template #head(COD_FAC_AR)="item">
        <div class="a" style="width: 90px">
          <span>{{ item.label }}</span>
        </div>
      </template>
       <template #head(TIPO_FAC_AR)="item">
        <div class="a" style="width: 80px">
          <span>{{ item.label }}</span>
        </div>
      </template>
      <template #head(DATA_DESATIVACAO)="item">
        <div class="a" style="width: 90px">
          <span>{{ item.label }}</span>
        </div>
      </template>
      <template #cell(NUM_DISPONIVEL)="{ item }">
        <div class="mr-0 text-center" data-align="right">
          {{ item.NUM_DISPONIVEL }}
        </div>
      </template> 
      <template #cell(QUANTIDADE)="{ item }">
        <div v-if="item === items[0]" class="mr-0 text-center font-weight-bold large-text" data-align="right">
          {{ item.QUANTIDADE }}
        </div>
        <div v-else class="mr-0 text-center" data-align="right">
          {{ item.QUANTIDADE }}
        </div>
      </template>                      
      <template #cell(DESCRICAO)="{ item }">
        <div class="mr-0" data-align="right">
          {{ item.DESCRICAO }}
        </div>
      </template>
      <template #cell(TIPO_FAIXA)="{ item }">
        <div class="mr-0" data-align="right">
          {{ item.TIPO_FAIXA }}
        </div>
      </template>      
      <template #cell(NUM_INICIAL)="{ item }">
        <div class="mr-0" data-align="right">
          {{ item.NUM_INICIAL }}
        </div>
      </template>
      <template #cell(NUM_FINAL)="{ item }">
        <div class="mr-0" data-align="right">
          {{ item.NUM_FINAL }}
        </div>
      </template>
      <template #cell(DATA_INCLUSAO)="{ item }">
        <div class="mr-0" data-align="right">
          {{ item.DATA_INCLUSAO }}
        </div>
      </template>
      <template #cell(DATA_VALIDADE)="{ item }">
        <div v-if="item === items[0]" class="mr-0 text-center font-weight-bold large-text" data-align="right">
          {{ item.DATA_VALIDADE }}
        </div>
        <div v-else class="mr-0 text-center" data-align="right">
          {{ item.DATA_VALIDADE }}
        </div>
      </template>
      <template #cell(COD_FAC_AR)="{ item }">
        <div class="mr-0" data-align="right">
          {{ item.COD_FAC_AR }}
        </div>
      </template>
      <template #cell(TIPO_FAC_AR)="{ item }">
        <div class="mr-0" data-align="right">
          {{ item.TIPO_FAC_AR }}
        </div>
      </template>                                    
      <template #cell(DATA_DESATIVACAO)="{ item }">
        <div class="mr-0" data-align="right">
          {{ item.DATA_DESATIVACAO }}
        </div>
      </template>
    </b-table>
    
    <b-row class="d-flex justify-content-between mx-3">
      <b-col>
        <strong>Total de registros: {{ items.length }}</strong>
        <br />
        Página {{ currentPage }} de
        {{ Math.ceil(items.length / rowsPerPage) }}
      </b-col>
      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="rowsPerPage" aria-controls="my-table"
        align="right">
      </b-pagination>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    fields: Array,
  },
  data() {
    return {
      origemAcesso: "",
      userName: "",
      origemNome: "",
      detalhe: {},
      selectAllRows: false,
      rowsPerPage: 5,
      pageSizeMenu: [5, 10, 20, 50, 100, 200],
      currentPage: 1,
      ordenarPor: "",
      sortBy: "ID_CATEGORIA_PARCTO",
      ordenacaoDecrescente: false,
      ordenacaoDirecao: "asc",
    };
  },
  mounted() {},
  computed: {
    rows() {
      return this.items.length;
    },
  },
  methods: {
    toggleSelect() {
      this.selectAllRows = !this.selectAllRows;
      if (this.selectAllRows === true) this.selectAll();
      else this.clearAll();
    },

    rowClass(item, type) {
      // Verifica se a linha é do tipo 'row' e se é a primeira 
      if (type === 'row' && item === this.items[0]) {
        return 'table-danger';  // Aplica a classe 'table-danger' (fundo vermelho) à primeira linha
      }
      return '';  
    }   
  },
  async beforeMount() {
    this.userName = this.$store.getters.userInfo.preferred_username;
    this.origemAcesso = this.$store.getters.userInfo.origem;
    this.origemNome = this.$store.getters.userInfo.name;
  },
 
};
</script> 
<style scoped>
.table-sm td {
  padding: 0rem;
}

#ckbSelected {
  cursor: pointer;
}

.large-text {
  font-size: 1.0rem; 
}
</style>
